import {AUTHORIZATION} from './../constants/constants';

export function setAuth (token) {
  localStorage.setItem(AUTHORIZATION, token)
}

export function resetAuth () {
  localStorage.removeItem(AUTHORIZATION)
}
